// MARK://dhk8/admin-shell/lib/money
// MXN cents → display string. Minimal; mirrors the POS app's money formatting.
const fmt = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' })
export function mxn(cents: number): string { return fmt.format(cents / 100) }
export function parseMxnToCents(text: string): number {
  const n = Number(String(text).replace(/[^0-9.]/g, ''))
  return Number.isFinite(n) ? Math.round(n * 100) : 0
}
